
import { useEffect, useRef, useState } from "react"
import { NavLink, Link } from "react-router-dom";


export default function FileRenderComment({ files, isChild, showButton, deletFile, index, allFiles }) {


    const modalRefFile = useRef(null)
    const [indexFile, setindexFile] = useState(index)


    useEffect(() => {
        console.log(files.mimetype);
    }, [files])

    const openModalForShow = () => {
        console.log(allFiles);
        modalRefFile.current.style.display = "flex"
        console.log(window.location.hostname +  window.location.pathname);
    }

    const closeModal = () => {
        console.log(allFiles);
        modalRefFile.current.style.display = "none"
    }

    useEffect(() => {
        modalRefFile.current.style.display = "none"
    }, [])

    useEffect(() => {
        console.log(allFiles[indexFile], "allFiles");
    }, [])

    const next = () => {
        if (indexFile < allFiles.length - 1) {
            setindexFile((prevIndex) => prevIndex + 1);
        }
    }

    const prev = () => {
        if (indexFile > 0) {
            setindexFile((prevIndex) => prevIndex - 1);
        }
    }

   const handleDownload = () => {
        for (let i = 0; i < allFiles.length; i++) {
          const link = document.createElement('a');
          link.target = '_blank';
          link.href = allFiles[i].imgpath;
          link.click();
        }
      }

    return (
        <>
            {
                (() => {
                    if (files.mimetype == "image/png" || files.mimetype == "image/jpeg") {
                        return (
                            <>
                                <div className="fileCont">

                                    <div>
                                        <Link to={"https://xn--h1alceggc.xn--p1ai/" +files.fileName} target="_blank" download={"https://xn--h1alceggc.xn--p1ai/" + files.fileName}>
                                            <span class="material-symbols-outlined downloadSpan" >download</span>
                                        </Link>

                                        <img src={files.imgpath} alt=""  onClick={openModalForShow}/>

                                        {
                                            showButton ?
                                                <span class="material-symbols-outlined deletSpan" onClick={() => deletFile(index)}>close</span>
                                                :
                                                ""
                                        }

                                        <p>asdasd</p>
                                    </div>
                                </div>
                            </>
                        )

                    } else if (files.mimetype == "video/mp4") {
                        return (
                            <>

                                <div  className="fileCont">
                                    <Link to={files.imgpath} target="_blank" download>
                                        <span class="material-symbols-outlined downloadSpan" >download</span>
                                    </Link>
                                    <video  controls onClick={openModalForShow} >
                                        <source src={files.imgpath} type="video/mp4" />
                                    </video>
                                    {
                                        showButton ?
                                            <span class="material-symbols-outlined deletSpan" onClick={() => deletFile(index)}>close</span>
                                            :
                                            ""
                                    }

                                    <p>asdasd</p>
                                </div>
                            </>
                        )

                    } else {
                        return (
                            <>

                                <div  className="fileCont">
                                    <Link to={files.imgpath} target="_blank" download>
                                        <span class="material-symbols-outlined downloadSpan" >download</span>
                                    </Link>

                                    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="48" viewBox="0 0 37 48" fill="none" onClick={openModalForShow}>
                                        <path d="M25.2188 14.0625C23.4095 14.0625 21.9375 12.5905 21.9375 10.7812V0H5.15625C2.31309 0 0 2.31309 0 5.15625V42.8438C0 45.6869 2.31309 48 5.15625 48H31.4062C34.2494 48 36.5625 45.6869 36.5625 42.8438V14.0625H25.2188ZM7.6875 33.75H14.505C15.2816 33.75 15.9113 34.3796 15.9113 35.1562C15.9113 35.9329 15.2816 36.5625 14.505 36.5625H7.6875C6.91087 36.5625 6.28125 35.9329 6.28125 35.1562C6.28125 34.3796 6.91087 33.75 7.6875 33.75ZM6.28125 27.6562C6.28125 26.8796 6.91087 26.25 7.6875 26.25H28.3125C29.0891 26.25 29.7188 26.8796 29.7188 27.6562C29.7188 28.4329 29.0891 29.0625 28.3125 29.0625H7.6875C6.91087 29.0625 6.28125 28.4329 6.28125 27.6562ZM28.3125 18.75C29.0891 18.75 29.7188 19.3796 29.7188 20.1562C29.7188 20.9329 29.0891 21.5625 28.3125 21.5625H7.6875C6.91087 21.5625 6.28125 20.9329 6.28125 20.1562C6.28125 19.3796 6.91087 18.75 7.6875 18.75H28.3125Z" fill="#F5F5F5" />
                                        <path d="M24.75 10.7813C24.75 11.0397 24.9603 11.25 25.2188 11.25H35.9357C35.6772 10.7715 35.3445 10.3369 34.9499 9.96263L25.9103 1.41057C25.5636 1.08255 25.1732 0.804122 24.7501 0.583221V10.7813H24.75Z" fill="#F5F5F5" />
                                    </svg>

                                    {
                                        showButton ?
                                            <span class="material-symbols-outlined deletSpan" onClick={() => deletFile(index)}>close</span>
                                            :
                                            ""
                                    }

                                    <p>asdasd</p>
                                </div>
                            </>
                        )
                    }
                })()
            }


{/* mdaol========================================================================================================================== */}
            <div id="myModal" class="modalShowFile" ref={modalRefFile}>
                <div className="modalShowFilecontent">
                    <div className="modalShowFileHeader">
                    <Link to={allFiles[indexFile]?.imgpath} target="_blank" download>
                             <span class="material-symbols-outlined">download</span>
                    </Link>

                        
                       


                        <span class="material-symbols-outlined" onClick={closeModal}>close</span>


                       
                    </div>
                    <div className="modalShowFilemodal-body">
                        <button onClick={prev}><span class="material-symbols-outlined">arrow_back_ios</span></button>
                        


                        
                        <div>
                        {
                            (() => {
                                if (allFiles[indexFile]?.mimetype == "image/png" || allFiles[indexFile]?.mimetype == "image/jpeg") {
                                    return (

                                        <div >


                                            <img src={allFiles[indexFile]?.imgpath} alt="" />


                                            <p>{allFiles[indexFile]?.originalname}</p>
                                            <p>{allFiles.length }/{indexFile+1}</p>
                                        </div>

                                    )

                                } else if (allFiles[indexFile].mimetype == "video/mp4") {
                                    return (


                                        <div >

                                            <video width="750" height="500" controls >
                                                <source src={allFiles[indexFile]?.imgpath} type="video/mp4" />
                                            </video>


                                            <p>{allFiles[indexFile]?.originalname}</p>
                                            <p>{allFiles.length }/{indexFile+1}</p>
                                        </div>

                                    )

                                } else {
                                    return (

                                        <div>

                                            <svg xmlns="http://www.w3.org/2000/svg" width="37" height="48" viewBox="0 0 37 48" fill="none">
                                                <path d="M25.2188 14.0625C23.4095 14.0625 21.9375 12.5905 21.9375 10.7812V0H5.15625C2.31309 0 0 2.31309 0 5.15625V42.8438C0 45.6869 2.31309 48 5.15625 48H31.4062C34.2494 48 36.5625 45.6869 36.5625 42.8438V14.0625H25.2188ZM7.6875 33.75H14.505C15.2816 33.75 15.9113 34.3796 15.9113 35.1562C15.9113 35.9329 15.2816 36.5625 14.505 36.5625H7.6875C6.91087 36.5625 6.28125 35.9329 6.28125 35.1562C6.28125 34.3796 6.91087 33.75 7.6875 33.75ZM6.28125 27.6562C6.28125 26.8796 6.91087 26.25 7.6875 26.25H28.3125C29.0891 26.25 29.7188 26.8796 29.7188 27.6562C29.7188 28.4329 29.0891 29.0625 28.3125 29.0625H7.6875C6.91087 29.0625 6.28125 28.4329 6.28125 27.6562ZM28.3125 18.75C29.0891 18.75 29.7188 19.3796 29.7188 20.1562C29.7188 20.9329 29.0891 21.5625 28.3125 21.5625H7.6875C6.91087 21.5625 6.28125 20.9329 6.28125 20.1562C6.28125 19.3796 6.91087 18.75 7.6875 18.75H28.3125Z" fill="#F5F5F5" />
                                                <path d="M24.75 10.7813C24.75 11.0397 24.9603 11.25 25.2188 11.25H35.9357C35.6772 10.7715 35.3445 10.3369 34.9499 9.96263L25.9103 1.41057C25.5636 1.08255 25.1732 0.804122 24.7501 0.583221V10.7813H24.75Z" fill="#F5F5F5" />
                                            </svg>



                                            <p>{allFiles[indexFile]?.originalname}</p>
                                            <p>{allFiles.length }/{indexFile+1}</p>
                                        </div>

                                    )
                                }
                            })()
                        }
                        </div>
                        <button onClick={next}> <span class="material-symbols-outlined">arrow_forward_ios</span></button>
                       


                        

                    </div>

                </div>

            </div>
        </>
    )
}   